module.exports = __webpack_public_path__ + "static/media/page-break.6d81223c.svg";